export default __webpack_public_path__ + "static/media/pdf.12d7d7b4.svg";